import React, { useEffect, useState } from "react";
import { db } from "../firebase/Firebasedata";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import "./FirstPagePreviews.css";

// Fixed-ish float positions for each slot (roughly arranged behind the header)
const SLOTS = [
    { top: "10%",  left: "6%",  rotate: -8,  scale: 0.85, delay: 0 },
    { top: "6%",   left: "44%", rotate: -2,  scale: 0.8,  delay: 2.4 },
    { top: "14%",  right: "8%", rotate: 6,   scale: 0.95, delay: 1.2 },
    { top: "70%",  left: "10%", rotate: 4,   scale: 0.9,  delay: 0.6 },
    { top: "74%",  right: "6%", rotate: -5,  scale: 0.85, delay: 1.8 },
];

const CYCLE_MS = 5000;

function FirstPagePreviews() {
    const [projects, setProjects] = useState([]);
    const [cursor, setCursor] = useState(0);

    useEffect(() => {
        let cancelled = false;
        async function load() {
            const snap = await getDocs(query(collection(db, "Projects"), orderBy("order")));
            const items = [];
            snap.forEach(d => {
                const data = d.data();
                if (data.cover_img) items.push({ id: d.id, name: data.name, img: data.cover_img });
            });
            if (!cancelled) setProjects(items);
        }
        load();
        return () => { cancelled = true; };
    }, []);

    useEffect(() => {
        if (projects.length <= SLOTS.length) return;
        const t = setInterval(() => {
            setCursor(c => (c + 1) % projects.length);
        }, CYCLE_MS);
        return () => clearInterval(t);
    }, [projects.length]);

    if (projects.length === 0) return null;

    const visible = SLOTS.map((slot, i) => {
        const project = projects[(cursor + i) % projects.length];
        return { slot, project, key: `${slot.top}-${slot.left ?? slot.right}` };
    });

    return (
        <div className="preview-layer" aria-hidden="true">
            {visible.map(({ slot, project, key }) => (
                <div
                    key={key}
                    className="preview-card"
                    style={{
                        top: slot.top,
                        left: slot.left,
                        right: slot.right,
                        transform: `rotate(${slot.rotate}deg) scale(${slot.scale})`,
                        animationDelay: `${slot.delay}s`
                    }}
                >
                    <img src={project.img} alt="" loading="lazy" />
                    <span className="preview-label">{project.name}</span>
                </div>
            ))}
        </div>
    );
}

export default FirstPagePreviews;
